
import { type FetchMode, type TimelineIdSpec } from './types';

/**
 * タイムラインURLを生成
 * @param domain - Mastodonインスタンスのドメイン
 * @param idSpec - status のID指定
 * @param mode - 表示モード
 * @returns URL
 */
export function buildTimelineUrl(domain: string, idSpec: TimelineIdSpec, mode: FetchMode): string {
  let path: string;
  if (mode.type === 'user') {
    path = `/api/v1/accounts/${encodeURIComponent(mode.userId)}/statuses`;
  } else {
    path = '/api/v1/timelines/' + (mode.tag ? `tag/${encodeURIComponent(mode.tag)}` : 'public');
  }

  const idParam = idSpec.type === 'none' ? '' : `&${idSpec.type}_id=${encodeURIComponent(idSpec.id)}`;
  const localOnlyParam = mode.type === 'timeline' && mode.localOnly ? '&local=1' : '';
  const param = `?limit=40${idParam}${localOnlyParam}`;
  return "https://" + domain + path + param;
}
